import { on } from 'delegated-events'
import Pristine from 'pristinejs'

const SELECTORS = Selectors({
  subscribeForm: 'subscribe-form'
})

const $forms = document.querySelectorAll(SELECTORS.asClass('subscribeForm'))

const fn = {
  init: () => {
    fn.bindEvents()
  },

  bindEvents: () => {
    on('submit', SELECTORS.asClass('subscribeForm'), fn.handleSubmit)
  },

  handleSubmit: (e) => {
    e.preventDefault()

    const $form = e.target
    const $submitButton = $form.querySelector('[type=submit]')
    const $successMessage = $form.querySelector('.form-success-message')
    const $errorMessage = $form.querySelector('.form-error-message')

    $successMessage.style.display = 'none'
    $errorMessage.style.display = 'none'

    const pristine = new Pristine($form, {
      classTo: 'field',
      errorClass: 'has-error',
      successClass: 'has-success',
      errorTextParent: 'field',
      errorTextTag: 'div',
      errorTextClass: 'text-help'
    })

    if (!pristine.validate()) {
      return false
    }

    $submitButton.disabled = true

    $.post($form.action, $($form).serialize())
      .then(resp => {
        if (resp.success) {
          $form.querySelector('[type=email]').value = null
          $successMessage.innerHTML = resp.message
          $successMessage.style.display = 'block'
        } else {
          $errorMessage.innerHTML = resp.message
          $errorMessage.style.display = 'block'
        }
      })
      .fail(() => {
          $errorMessage.innerHTML = 'Sorry, there was a problem with your submission'
          $errorMessage.style.display = 'block'
      })
      .always(() => {
        $submitButton.disabled = false
      })
  }
}

export default {
  can: () => $forms.length,
  run: fn.init
}
